export default "__VITE_ASSET__d$qbNiSc__"